export default "__VITE_ASSET__DKvyXhlk__"